/**
 * @returns { {
*    'Content-Type': 'application/json',
*    Accept: 'application/json',
*    'X-Shopify-Storefront-Access-Token': string
* } }
*/
function getGraphQlHeaders () {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': window.apis.storefrontAccessToken
  }
}
/**
* Returns graphql request with no callback
* @param { {
*  query: string
*  variables?: unknown
* } } param0
* @returns { fetch }
*/

export function executeGraphQlQuery ({ query, variables }) {
  const url = window.apis.graphQlEndpoint
  // remove line breaks and double space for legibility
  const cleanQuery = query.replace(/\n/g, ' ').replace(/ {2}/g, '')
  const config = {
    method: 'post',
    headers: getGraphQlHeaders(),
    body: JSON.stringify({
      query: cleanQuery,
      // only add variables if they actually exist
      ...(variables ? { variables } : {})
    })
  }
  return fetch(url, config)
}

export const searchForBlogs = async (inputValue, paginationString) => {
  const query = `
    query searchAll($query: String!, $first: Int, $after: String) {
      search(query: $query, first: $first, types: ARTICLE, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ... on Article {
              id
              title
              excerpt
              handle
              tags
              onlineStoreUrl
              image {
                url
                altText
              }
            }
          }
        }
      }
    }`;

  const variables = {
    query: `${inputValue}`,
    first: 8,
    ...(paginationString && { after: paginationString })
  }

  const response = await executeGraphQlQuery({ query, variables })
    .then(res => res.json())
    .then(data => {
      if (data.errors) {
        throw data
      }
      return data.data
    })
    .catch(error => {
      console.warn('error', error)
      return null
    })

  // have results/no results so we can build our suggestions HTML
  return response ? response : null
}